import { useEffect, useRef, useState } from 'react'
import Confetti from 'react-confetti'
import { useLocalStorage, useWindowSize } from 'usehooks-ts'

import WhatsNext from '~/features/onboarding/WhatsNext.tsx'
import { useWorkspace } from '~/features/workspaces/data.ts'

import MenuUls from './MenuUls.tsx'
import PlatformStatus from './PlatformStatus.tsx'
import { WorkspaceSelect } from './WorkspaceSelect.tsx'

export function Sidebar() {
  const [showConfetti, setShowConfetti] = useState(false)
  const [onboardingCompleted, setOnBoardingCompleted] = useLocalStorage(
    'onboardingCompleted',
    false,
  )
  const [confettiStyle, setConfettiStyle] = useState({ width: 0, height: 0, style: {} })
  const ref = useRef<HTMLElement>(null)
  const { height } = useWindowSize()
  const { data: workspaceData } = useWorkspace()

  useEffect(() => {
    const sidebar = ref.current

    if (!sidebar) return

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.target instanceof HTMLElement) {
          setConfettiStyle({
            width: entry.contentRect.width,
            height,
            style: { inset: `0px ${entry.target.offsetLeft}px` },
          })
        }
      }
    })

    if (sidebar) {
      resizeObserver.observe(sidebar)
    }

    return () => {
      resizeObserver.unobserve(sidebar)
      resizeObserver.disconnect()
    }
  }, [height, ref])

  const handleDoneOnboarding = () => {
    setShowConfetti(true)
  }

  return (
    <aside className="sidebar" ref={ref}>
      <WorkspaceSelect />

      <nav className="main-menu">
        <MenuUls />
      </nav>

      <PlatformStatus />

      {showConfetti && (
        <Confetti
          {...confettiStyle}
          recycle={false}
          numberOfPieces={150}
          tweenDuration={1000}
          gravity={0.4}
          onConfettiComplete={() => setOnBoardingCompleted(true)}
        />
      )}

      {!onboardingCompleted && !workspaceData?.workspace.cancelled && (
        <WhatsNext handleDoneOnboarding={handleDoneOnboarding} />
      )}
    </aside>
  )
}
